import { BaseModel } from '../base-model'
import { BaseModelData } from '../base-model-data'
import { Clinician } from '../clinician'
import { LOG_TYPE } from './estimate-types'

// History event payload. Values are primitives (amounts as numbers, flags like
// `refinalize` as booleans, everything else as strings) — never nested objects,
// so template interpolation can't render "[object Object]". Consumers still
// narrow per field (see describe-history-entry.ts).
export type EstimateHistoryMessageData = Record<string, string | number | boolean>

export interface EstimateHistoryData extends BaseModelData {
  actor: {
    clinician?: Clinician
    type: 'clinician' | 'patientpal'
  }
  appointmentId?: string
  estimateId?: string
  type: string
  level: number
  message: string
  messageData: EstimateHistoryMessageData
}

export class EstimateHistoryModel extends BaseModel {
  id: string
  actor: {
    clinician?: Clinician
    type: 'clinician' | 'patientpal'
  }
  appointmentId?: string
  estimateId?: string
  clinicId: string
  type: string
  level: number
  message: string
  messageData: EstimateHistoryMessageData

  constructor(data: EstimateHistoryData) {
    super(data, true)
  }

  public get actorName(): string {
    if (this.actor.type === 'clinician' && this.actor.clinician) {
      return this.actor.clinician.name
    } else if (this.actor.type === 'patientpal') {
      return 'System'
    } else {
      return 'Unknown Actor'
    }
  }

  public isSendAction(): boolean {
    const sendTypes = [
      LOG_TYPE.ESTIMATE_INVOICE_SENT,
      LOG_TYPE.ESTIMATE_FAILED_INVOICE_SENT,
    ]

    return sendTypes.includes(this.type as LOG_TYPE)
  }
}
